import { useEffect, useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { postData } from '../Api';
import TwButton from '../controls/button';
import { Modal, Title } from './Display';
import { Password, TextBox } from './Form';
import { LeftComponents } from './Layout';

// Custom scrollbar styles
const scrollbarStyles = `
    /* For Webkit browsers (Chrome, Safari) */
    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    
    ::-webkit-scrollbar-track {
        background: transparent;
    }
    
    ::-webkit-scrollbar-thumb {
        background: #9ca3af;
        border-radius: 3px;
    }
    
    .dark ::-webkit-scrollbar-thumb {
        background: #4b5563;
    }
    
    /* For Firefox */
    * {
        scrollbar-width: thin;
        scrollbar-color: #9ca3af transparent;
    }
    
    .dark * {
        scrollbar-color: #ffffff22 transparent;
    }
`;

const EditProfile = ({ onDismiss }) => {
    useEffect(() => {
        postData('/api/auth/user-info').then(user => {
            setUser({
                title: user.user.title,
                password: '********',
            });
        });
    }, []);
    const [user, setUser] = useState(null);
    const saveInfo = () => {
        postData('/api/auth/save-user-info', {
            title: user.title,
            password: user.password,
        }).then(onDismiss);
    }
    return <div dir="rtl" className="flex flex-col gap-4">
        <Title>ویرایش پروفایل</Title>
        <TextBox value={user?.title} onChange={(e) => setUser({...user, title: e})} label="نام و نام خانوادگی" />
        <Password value={user?.password} onChange={(e) => setUser({...user, password: e})} label="رمز عبور" />

        <LeftComponents>
            <TwButton color="danger" style="light" size="sm" onClick={onDismiss}>لغو</TwButton>
            <TwButton color="primary" size="sm" onClick={saveInfo}>ذخیره</TwButton>
        </LeftComponents>
    </div>;
};

export const IncreaseCredit = ({ onDismiss }) => {
    const [amount, setAmount] = useState(0);
    const saveInfo = () => {
        postData('/api/auth/increase-credit', {
            amount: amount,
        }).then((res) => {
            if (res.success) {
                // onDismiss();
            }
            else {
                alert(res.message);
            }
        });
    }
    return <div dir="rtl" className="flex flex-col gap-4">
        <Title>افزایش اعتبار</Title>
        <TextBox value={amount} onChange={(e) => setAmount(e)} label="مبلغ" />
        <LeftComponents>
            <TwButton color="danger" style="light" size="sm" onClick={onDismiss}>لغو</TwButton>
            <TwButton color="primary" size="sm" onClick={saveInfo}>ذخیره</TwButton>
        </LeftComponents>
    </div>;
}

function Dashboard() {
    // Add style tag for scrollbar styles
    useEffect(() => {
        const styleTag = document.createElement('style');
        styleTag.textContent = scrollbarStyles;
        document.head.appendChild(styleTag);
        
        return () => {
            document.head.removeChild(styleTag);
        };
    }, []);

    const navigate = useNavigate();
    const [settings, setSettings] = useState([]);
    const [showMenu, setShowMenu] = useState(false);
    const [theme, setTheme] = useState(window.localStorage.getItem('pargar-panel-theme') || 'light');
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [expandedGroups, setExpandedGroups] = useState(() => {
        try {
            const saved = window.localStorage.getItem('sidebar-expanded-groups');
            if (saved) {
                return JSON.parse(saved);
            }
            // Initialize all groups as closed (false)
            const initialState = {};
            settings.sidebar?.categories.forEach((category, ci) => {
                category.groups.forEach((group, gi) => {
                    if (group.links?.length > 0) {
                        initialState[`${ci}-${gi}`] = false;
                    }
                });
            });
            return initialState;
        } catch (err) {
            console.error('Error loading sidebar state:', err);
            return {};
        }
    });

    // Update expandedGroups when settings change (for first load)
    useEffect(() => {
        if (Object.keys(expandedGroups).length === 0 && settings.sidebar) {
            const initialState = {};
            settings.sidebar.categories.forEach((category, ci) => {
                category.groups.forEach((group, gi) => {
                    if (group.links?.length > 0) {
                        initialState[`${ci}-${gi}`] = true;
                    }
                });
            });
            setExpandedGroups(initialState);
            window.localStorage.setItem('sidebar-expanded-groups', JSON.stringify(initialState));
        }
    }, [settings.sidebar]);

    const toggleGroup = (categoryIndex, groupIndex) => {
        setExpandedGroups(prev => {
            const newState = {
                ...prev,
                [`${categoryIndex}-${groupIndex}`]: !prev[`${categoryIndex}-${groupIndex}`]
            };
            window.localStorage.setItem('sidebar-expanded-groups', JSON.stringify(newState));
            return newState;
        });
    };

    const changeTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        window.localStorage.setItem('pargar-panel-theme', newTheme);
        themeInit(newTheme);
    }

    const themeInit = (theme) => {
        document.documentElement.classList.remove('light');
        document.documentElement.classList.remove('dark');
        document.documentElement.classList.add(theme);
    }

    const handleLogout = () => {
        localStorage.removeItem('admin_auth_token');
        navigate('/admin/site-admin/login');
    };

    const [credit, setCredit] = useState(0);

    // Support notification badge: number of tickets waiting for a support reply.
    const [supportAwaiting, setSupportAwaiting] = useState(0);
    // Sidebar badge: number of open (not closed) support tickets.
    const [supportOpen, setSupportOpen] = useState(0);
    useEffect(() => {
        let active = true;
        const loadSupportSummary = () => {
            postData('/api/panel/page/taroff-support-requests/summary')
                .then((res) => {
                    if (!active) return;
                    setSupportAwaiting(res.data?.awaiting_admin || 0);
                    setSupportOpen(res.data?.open || 0);
                })
                .catch(() => {});
        };
        loadSupportSummary();
        const timer = setInterval(loadSupportSummary, 60000);
        return () => { active = false; clearInterval(timer); };
    }, []);

    // کارتابل badges: tasks assigned to me that someone else last touched
    // (the bell), and how many open tasks are mine (the sidebar counter).
    const [tasksAwaiting, setTasksAwaiting] = useState(0);
    const [tasksMine, setTasksMine] = useState(0);
    useEffect(() => {
        let active = true;
        const loadTasksSummary = () => {
            postData('/api/panel/page/taroff-tasks/summary')
                .then((res) => {
                    if (!active) return;
                    setTasksAwaiting(res.data?.awaiting_me || 0);
                    setTasksMine(res.data?.mine || 0);
                })
                .catch(() => {});
        };
        loadTasksSummary();
        const timer = setInterval(loadTasksSummary, 60000);
        return () => { active = false; clearInterval(timer); };
    }, []);

    // Counter badges shown next to specific sidebar links, keyed by their path.
    const sidebarBadges = {
        '/taroff/support/requests': supportOpen,
        '/taroff/tasks?q-bucket=mine': tasksMine,
    };
    const sidebarBadge = (path) => {
        const count = sidebarBadges[path];
        if (!count) return null;
        return <span className="ms-2 min-w-[20px] h-[20px] px-1.5 inline-flex items-center justify-center rounded-full bg-red-600 text-white text-[11px] font-bold leading-none">
            {count > 99 ? '۹۹+' : count.toLocaleString('fa-IR')}
        </span>;
    };

    const handleIncreaseCredit = () => {
        setModal(
            <Modal onDismiss={() => setModal(null)}>
                <IncreaseCredit onDismiss={() => setModal(null)} />
            </Modal>
        );
    };

    const [modal, setModal] = useState(null);
    const handleEditProfile = () => {
        setModal(
            <Modal onDismiss={() => setModal(null)}>
                <EditProfile onDismiss={() => setModal(null)} />
            </Modal>
        );
    };

    useEffect(() => {
        themeInit(theme);
    }, [theme]);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const token = localStorage.getItem('admin_auth_token');
                if (!token) {
                    navigate('/admin/site-admin/login');
                    return;
                }

                const userInfo = await postData('/api/auth/user-info');
                setUser(userInfo);
            } catch (error) {
                console.error('Auth error:', error);
                localStorage.removeItem('admin_auth_token');
                navigate('/admin/site-admin/login');
            } finally {
                // const credit = await postData('/api/panel/user-credit');
                // setCredit(credit.credit);
                const result = await postData('/api/panel/settings');
                setSettings(result.settings);
                setLoading(false);
            }
        };

        checkAuth();
    }, [navigate]);

    if (loading) {
        return <div className="flex items-center justify-center min-h-screen">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900 dark:border-white"></div>
        </div>;
    }

    return <>
        <div dir="rtl" className="font-iransans text-gray-900 dark:text-white">
            {showMenu && <div className="relative bg-zinc-900 lg:hidden" role="dialog" aria-modal="true">
                <div className="fixed z-50 inset-0 bg-gray-900/80" aria-hidden="true"></div>

                <div className="fixed z-[90] inset-0 flex">
                    <div className="relative z-50 ml-16 flex w-full max-w-xs flex-1">
                        <div className="absolute right-full top-0 flex w-16 justify-center pt-5">
                            <button type="button" className="-m-2.5 p-2.5" onClick={() => setShowMenu(!showMenu)}>
                                <span className="sr-only">Close sidebar</span>
                                <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white dark:bg-gray-900 dark:ring-1 dark:ring-white/10 px-6 pb-4">
                            <div className="flex h-16 shrink-0 items-center">
                                <img className="h-8 w-auto me-3" src={`${process.env.PUBLIC_URL}/taroff-logo.png`} alt="لوگو" />
                                <div className="font-bold text-lg">تعارف</div>
                                <div className="grow"></div>
                            </div>
                            <nav className="flex flex-1 flex-col">
                                <ul role="list" className="flex flex-1 flex-col gap-y-7">
                                    {settings.sidebar?.categories.map((c, ci) => <li key={ci} className="border-b border-gray-100 dark:border-gray-800 pb-6">
                                        <div className="text-sm font-bold mb-4 text-gray-900 dark:text-gray-300 uppercase tracking-wider">{c.title}</div>
                                        <ul role="list" className="space-y-2">
                                            {c.groups.map((g, gi) => {
                                                const link = g.path?.length > 0 ? `/admin/site-admin${g.path}` : `/admin/site-admin${g.links[0]?.path ?? '/'}`
                                                const isExpanded = expandedGroups[`${ci}-${gi}`] !== false;
                                                return <li key={gi} className="space-y-2">
                                                    <div className="flex items-center [&:hover_i]:opacity-100">
                                                        <Link 
                                                            to={link} 
                                                            onClick={() => setShowMenu(false)} 
                                                            className="p-2.5 flex items-center grow rounded-lg text-sm font-medium leading-6 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                                                        >
                                                            {g.icon && <i className={g.icon + ' fa-lg fa-fw me-3 text-gray-400 dark:text-gray-500'}></i>} 
                                                            {g.title}
                                                        </Link>
                                                        {g.links?.length > 0 && (
                                                            <button
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    toggleGroup(ci, gi);
                                                                }}
                                                                className="p-2 text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                                                            >
                                                                <i className={`fal fa-chevron-${isExpanded ? 'down' : 'left'} transition-transform duration-200`}></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                    {isExpanded && g.links?.map((l, k) => <div key={k} className="ps-9">
                                                        <div className="flex items-center [&:hover_i]:opacity-100 relative">
                                                            <div className="absolute w-px h-full bg-gray-200 dark:bg-gray-700 right-[-17px]"></div>
                                                            <Link 
                                                                to={`/admin/site-admin${l.path}`} 
                                                                onClick={() => setShowMenu(false)} 
                                                                className="py-2 px-3 grow flex items-center text-sm text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-md transition-colors duration-150 relative"
                                                            >
                                                                <div className="absolute w-2 h-px bg-gray-200 dark:bg-gray-700 right-[-17px] top-1/2"></div>
                                                                {l.title}
                                                                {sidebarBadge(l.path)}
                                                            </Link>
                                                        </div>
                                                    </div>)}
                                                </li>
                                            })}
                                        </ul>
                                    </li>)}
                                    <li>
                                        <div className="text-xs font-semibold leading-6 text-gray-400 dark:text-gray-600">پنل</div>
                                        <ul role="list" className="-mx-2">
                                            <li>
                                                <Link to="/admin/site-admin" className="group flex items-center gap-x-3 p-2 rounded-md text-sm font-semibold leading-6 text-gray-700 dark:text-gray-400">
                                                    <i className="fal fa-home fa-fw fa-lg"></i> خانه
                                                </Link>
                                                <div onClick={() => changeTheme()} className="group flex items-center gap-x-3 p-2 rounded-md text-sm font-semibold leading-6 text-gray-700 dark:text-gray-400">
                                                    <i className={(theme === 'dark' ? 'fa-sun' : 'fa-moon') + ' fal fa-fw fa-lg'}></i> {theme === 'dark' ? 'تم روز' : 'تم شب'}
                                                </div>
                                                <div onClick={handleLogout} className="group flex items-center gap-x-3 p-2 rounded-md text-sm font-semibold leading-6 text-gray-700 dark:text-gray-400 cursor-pointer">
                                                    <i className="fal fa-sign-out fa-fw fa-lg"></i> خروج
                                                </div>
                                            </li>
                                            {/* {panel.settings.toolbarLeftItems.map((c, i) => <li key={i}>
                                                <div onClick={() => {
                                                    panel.setState({ showMenu: !panel.state.showMenu });
                                                    panel.buttonAction({
                                                        actions: c.actions,
                                                        action: c.action,
                                                        actionParams: c.actionParams,
                                                    })
                                                }} className="group flex items-center gap-x-3 p-2 rounded-md text-sm font-semibold leading-6 text-gray-700 dark:text-gray-400">
                                                    {(c.rightIcon || c.icon) && <i className={(c.rightIcon || c.icon) + ' fal fa-fw fa-lg'}></i>} {c.text || c.tooltip}
                                                </div>
                                            </li>)} */}
                                        </ul>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>}

            <div className="dark hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
                <div className="flex grow flex-col gap-y-5 overflow-y-auto border-l border-gray-200 dark:border-none bg-white px-6 pb-4 dark:bg-cyan-950">
                    <div className="flex h-16 shrink-0 items-center border-b border-gray-100 dark:border-gray-800">
                        <div className="font-bold text-gray-900 dark:text-gray-300 text-lg">تعارف</div>
                        <div className="grow"></div>
                        <img className="h-8 w-auto me-3" src={`${process.env.PUBLIC_URL}/taroff-logo.png`} alt="لوگو" />
                    </div>
                    <nav className="flex flex-1 flex-col">
                        <ul role="list" className="flex flex-1 flex-col gap-y-7">
                            {settings.sidebar?.categories.map((c, ci) => <li key={ci} className="border-b border-gray-100 dark:border-gray-800 pb-6">
                                <div className="text-sm font-bold mb-4 text-gray-900 dark:text-gray-300 uppercase tracking-wider">{c.title}</div>
                                <ul role="list" className="space-y-2">
                                    {c.groups.map((g, gi) => {
                                        const link = g.path?.length > 0 ? `/admin/site-admin${g.path}` : `/admin/site-admin${g.links[0]?.path ?? '/'}`
                                        const isExpanded = true; // expandedGroups[`${ci}-${gi}`] !== false;
                                        return <li key={gi} className="space-y-2">
                                            <div className="flex items-center [&:hover_i]:opacity-100">
                                                <Link 
                                                    to={link} 
                                                    className="p-2.5 flex items-center grow rounded-lg text-sm font-medium leading-6 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                                                >
                                                    {g.icon && <i className={g.icon + ' fa-lg fa-fw me-3 text-gray-400 dark:text-gray-300'}></i>} 
                                                    {g.title}
                                                </Link>
                                                {g.links?.length > 0 && (
                                                    <button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            toggleGroup(ci, gi);
                                                        }}
                                                        className="p-2 text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                                                    >
                                                        <i className={`fal fa-chevron-${isExpanded ? 'down' : 'left'} transition-transform duration-200`}></i>
                                                    </button>
                                                )}
                                            </div>
                                            {isExpanded && g.links?.map((l, k) => <div key={k} className="ps-9">
                                                <div className="flex items-center [&:hover_i]:opacity-100 relative">
                                                    <div className="absolute w-px h-full bg-gray-200 dark:bg-gray-400 right-[-17px]"></div>
                                                    <Link 
                                                        to={`/admin/site-admin${l.path}`} 
                                                        className="py-2 px-3 grow flex items-center text-sm text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-md transition-colors duration-150 relative"
                                                    >
                                                        <div className="absolute w-2 h-px bg-gray-200 dark:bg-gray-400 right-[-17px] top-1/2"></div>
                                                        {l.title}
                                                        {sidebarBadge(l.path)}
                                                    </Link>
                                                </div>
                                            </div>)}
                                        </li>
                                    })}
                                </ul>
                            </li>)}
                            
                            {/* User section */}
                            <li className="mt-auto pt-4 border-t border-gray-200 dark:border-gray-800">
                                <div className="flex items-center p-2">
                                    <div className="flex-1">
                                        <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{user?.full_name || user?.username}</p>
                                        <p className="text-xs text-gray-500 dark:text-gray-400">{user?.email}</p>
                                    </div>
                                    <TwButton
                                        color="danger"
                                        style="light"
                                        size="sm"
                                        onClick={handleLogout}
                                        icon="sign-out"
                                    >
                                        خروج
                                    </TwButton>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            <div className="lg:pr-72">
                <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-950 px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
                    <div className="flex grow items-center flex-row lg:hidden">
                        <div>تعارف</div>
                        <div className="grow"></div>
                        <button type="button" className="-m-2.5 p-2.5 text-gray-700" onClick={() => setShowMenu(!showMenu)}>
                            <span className="sr-only">Open sidebar</span>
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                            </svg>
                        </button>
                    </div>

                    <div className="hidden lg:flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
                        <div className="flex items-center grow gap-x-2">
                            {/* {panel.settings?.toolbarRightItems.map((c, i) => <ToolbarComponent key={i} component={c} panel={panel} />)} */}
                            <TwButton color="secondary" style="light" size="sm" onClick={() => navigate('/admin/site-admin')} icon="home"></TwButton>
                            <TwButton color="secondary" style="light" size="sm" onClick={() => changeTheme()} icon={theme === 'dark' ? 'sun' : 'moon'}></TwButton>
                            <div className="relative inline-flex">
                                <TwButton color={supportAwaiting > 0 ? 'warn' : 'secondary'} style="light" size="sm" onClick={() => navigate('/admin/site-admin/taroff/support/requests?q-bucket=awaiting_admin')} icon="bell" tooltip="درخواست‌های پشتیبانی بی‌پاسخ"></TwButton>
                                {supportAwaiting > 0 && (
                                    <span className="absolute -top-1.5 -left-1.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-red-600 text-white text-[11px] font-bold leading-none">
                                        {supportAwaiting > 99 ? '۹۹+' : supportAwaiting.toLocaleString('fa-IR')}
                                    </span>
                                )}
                            </div>
                            <div className="relative inline-flex">
                                <TwButton color={tasksAwaiting > 0 ? 'warn' : 'secondary'} style="light" size="sm" onClick={() => navigate('/admin/site-admin/taroff/tasks?q-bucket=awaiting_me')} icon="list-check" tooltip="کارهای کارتابل که منتظر شما هستند"></TwButton>
                                {tasksAwaiting > 0 && (
                                    <span className="absolute -top-1.5 -left-1.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-red-600 text-white text-[11px] font-bold leading-none">
                                        {tasksAwaiting > 99 ? '۹۹+' : tasksAwaiting.toLocaleString('fa-IR')}
                                    </span>
                                )}
                            </div>
                            <div className="grow"></div>
                            {/* {panel.settings?.toolbarLeftItems.map((c, i) => <ToolbarComponent key={i} component={c} panel={panel} />)} */}
                            {/* اعتبار: <span dir="ltr" className={`${credit < 0 ? 'text-red-500' : 'text-green-500'}`}>{credit || 0}</span> */}
                            {/* <TwButton color="secondary" style="light" size="sm" onClick={handleIncreaseCredit} icon="user">افزایش اعتبار</TwButton> */}
                            {/* <TwButton color="secondary" style="light" size="sm" onClick={handleEditProfile} icon="user">ویرایش پروفایل</TwButton> */}
                            <TwButton color="secondary" style="light" size="sm" onClick={handleLogout} icon="sign-out">خروج</TwButton>
                        </div>
                    </div>
                </div>

                <main className="py-10">
                    <div className="px-4 sm:px-6 lg:px-8">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
        {modal && modal}
    </>
}

export default Dashboard; 